<template>
  <div>
    <!-- index -->
  </div>
</template>

<script>
import cards from './cards'
import transactions from './transactions'
import settings from './settings'
import cardtransactions from './cardtransactions'

export default {
  alias: 'evedpay',
  data() {
    return {
      //
      tabs: [
        { label: 'Cards', title: 'Active Cards', component: cards },
        { label: 'Transactions', title: 'All Transactions', component: transactions },
        { label: 'Settings', title: 'Settings', component: settings },
        { label: 'CardTransactions', title: 'Card Transactions', component: cardtransactions }
      ]
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/index.vue